import { Component, OnInit, } from '@angular/core';

import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';
import { Router } from "@angular/router";

@Component({
  selector: 'app-profile-update',
  templateUrl: './profile-update.component.html',
  styleUrls: ['./profile-update.component.css']
})
export class ProfileUpdateComponent implements OnInit {

  private subscription: Subscription = new Subscription();

  constructor(private userService: UserService, private router: Router) {

    if (!localStorage.getItem('currentUserId')) {
      this.router.navigate(["auth"], { queryParams: { returnUrl: "profile-update", type: "login" } });


    }


    // user.sendEmailVerification()
    //   .then(function() {
    //     window.alert("verification send");
    //     // Verification email sent.
    //   })
    //   .catch(function(error) {
    //     // Error occurred. Inspect error.code.
    //     window.alert("error : " + error.message);
    //   });
  }

  ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/profile-update.component.ts